import { Button, ButtonGroup, Col, Input, Label } from "reactstrap";
import { Option1, Option2 } from "../../../../constants";
import { BoxButtonProp } from "../../../../types/Component";

const CheckBoxButton:React.FC<BoxButtonProp> = ({ item }) => {
  return (
    <Col xl="6" sm="12">
      <ButtonGroup className={item.btnClass}>
        <Button color={item.colorClass}>
          <div className={item.divClass}>
            <Input id={item.id1} type="checkbox" />
            <Label htmlFor={item.id1}>{Option1}</Label>
          </div>
        </Button>
        <Button color={item.colorClass}>
          <div className={item.divClass}>
            <Input id={item.id2} type="checkbox" />
            <Label htmlFor={item.id2}>{Option2}</Label>
          </div>
        </Button>
      </ButtonGroup>
    </Col>
  );
};

export default CheckBoxButton;